import { RefObject, useRef } from 'react';
import { getShouldUseReportV2 } from '~/growthbook';
import AllReceiptTable from '../../AllReceiptTable';
import { ReceiptTableV2 } from './ReceiptTableV2';

interface IProps {
  filters: {
    transactionDate: string;
  };
  scrollRef?: RefObject<any>;
  onScroll: () => void;
  sort: {
    field: string;
    order: string;
  };
  changeSort: (field: string) => void;
}

export const AllReceiptTableManager = ({
  filters,
  changeSort,
  onScroll,
  sort,
  scrollRef,
}: IProps) => {
  const isReportV2Enabled = useRef(getShouldUseReportV2()).current;

  if (isReportV2Enabled) {
    return <ReceiptTableV2 filters={filters} />;
  }

  // @ts-expect-error -- AllReciptTable is a component that is not typed
  return <AllReceiptTable ref={scrollRef} onScroll={onScroll} sort={sort} onSort={changeSort} />;
};
